import styled from 'styled-components'

const StyledLoginView = styled.div``

export default StyledLoginView
